import { render } from "./AssignOneAccount.vue?vue&type=template&id=fab88744&scoped=true"
import script from "./AssignOneAccount.vue?vue&type=script&lang=js"
export * from "./AssignOneAccount.vue?vue&type=script&lang=js"

import "./AssignOneAccount.vue?vue&type=style&index=0&id=fab88744&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab88744"]])

export default __exports__